import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useQuery } from 'data-fetching-client';
import UISelect from 'UIComponents/input/UISelect';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIBadge from 'UIComponents/badge/UIBadge';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { getFormattedMessageWithObjectTypeName } from 'automation-ui-i18n/i18nUtils';
import { GET_OBJECT_TYPE_BY_ID } from 'automation-ui-references/object-type-properties/ObjectTypesQueries';
import FormattedMessageWithSourceAndTargetObjectTypeNames from 'automation-ui-formula-editor/fetch-object-panel/components/FormattedMessageWithSourceAndTargetObjectTypeNames';
import { useAssociationDefinitions } from 'automation-ui-associations/hooks/associationDefinitionsHooks';
import findAssociationDefinitions from 'automation-ui-associations/utils/findAssociationDefinitions';
import AddDataSourceFilterRecordsByTypes from 'automation-ui-formula-editor/fetch-object-panel/constants/AddDataSourceFilterRecordsByTypes';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
const AddDataSourceFilterRecordsBy = ({
  flowObjectTypeId,
  objectTypeId,
  onChange,
  value,
  readOnly
}) => {
  const associationDefinitionsQuery = useAssociationDefinitions([flowObjectTypeId]);
  const {
    data: flowObjectTypeData
  } = useQuery(GET_OBJECT_TYPE_BY_ID, {
    variables: {
      objectTypeId: flowObjectTypeId
    }
  });
  const flowObjectTypeDefinition = flowObjectTypeData === null || flowObjectTypeData === void 0 ? void 0 : flowObjectTypeData.objectTypeById;
  const hasAssociationToFlowObjectType = findAssociationDefinitions(flowObjectTypeId, objectTypeId, associationDefinitionsQuery).length > 0;
  const dropdownOptions = [{
    text: /*#__PURE__*/_jsx(UITruncateString, {
      children: /*#__PURE__*/_jsx(FormattedMessageWithSourceAndTargetObjectTypeNames, {
        message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.filter-object-by.options.associated-header",
        sourceObjectTypeId: flowObjectTypeId,
        targetObjectTypeId: objectTypeId
      })
    }),
    options: [{
      text: flowObjectTypeDefinition ? getFormattedMessageWithObjectTypeName({
        baseLangKey: 'automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.filter-object-by.options.association-label.title_cob',
        objectTypeId: flowObjectTypeId,
        objectTypeDefinition: flowObjectTypeDefinition
      }) : I18n.text('automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.filter-object-by.options.association-label.title'),
      help: /*#__PURE__*/_jsx(FormattedMessageWithSourceAndTargetObjectTypeNames, {
        message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.filter-object-by.options.association-label.help",
        sourceObjectTypeId: flowObjectTypeId,
        targetObjectTypeId: objectTypeId
      }),
      value: AddDataSourceFilterRecordsByTypes.ASSOCIATION_LABEL,
      disabled: !hasAssociationToFlowObjectType
    }]
  }, {
    text: /*#__PURE__*/_jsx(UITruncateString, {
      children: /*#__PURE__*/_jsx(FormattedMessageWithSourceAndTargetObjectTypeNames, {
        message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.filter-object-by.options.unassociated-header",
        sourceObjectTypeId: flowObjectTypeId,
        targetObjectTypeId: objectTypeId
      })
    }),
    options: [{
      text: I18n.text('automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.filter-object-by.options.property-matching.title'),
      help: /*#__PURE__*/_jsx(FormattedMessageWithSourceAndTargetObjectTypeNames, {
        message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.filter-object-by.options.property-matching.help",
        sourceObjectTypeId: flowObjectTypeId,
        targetObjectTypeId: objectTypeId
      }),
      value: AddDataSourceFilterRecordsByTypes.MATCHING_PROPERTY,
      badge: /*#__PURE__*/_jsx(UIBadge, {
        use: "beta",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-formula-editor.badge.beta"
        })
      })
    }, {
      text: I18n.text('automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.filter-object-by.options.property-value.title'),
      help: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.filter-object-by.options.property-value.help_cob",
        objectTypeId: objectTypeId
      }),
      value: AddDataSourceFilterRecordsByTypes.PROPERTY_VALUE,
      badge: /*#__PURE__*/_jsx(UIBadge, {
        use: "beta",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-formula-editor.badge.beta"
        })
      })
    }]
  }];
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.filter-object-by.title_cob",
      objectTypeId: objectTypeId
    }),
    required: true,
    children: /*#__PURE__*/_jsx(UISelect, {
      options: dropdownOptions,
      onChange: onChange,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.filter-object-by.placeholder"
      }),
      value: value,
      "data-test-id": "select-record-filter-by",
      readOnly: readOnly
    })
  });
};
export default AddDataSourceFilterRecordsBy;